<div class="contentLayout__container">
  <div class="contentLayout">
    <mat-sidenav-container [hasBackdrop]="isHandset$ | async">
      <mat-sidenav
        #snav
        [mode]="(isHandset$ | async) ? 'over' : 'side'"
        [opened]="isSideNavOpen$"
        (openedChange)="onSidenavOpenedChange($event)"
        [class.is-collapsed]="isCollapsed$"
        id="main"
        disableClose="false"
      >
        <div class="sidebar" [class.sidebar--collapsed]="isCollapsed$">
          <!-- Brand + location switcher -->
          <div class="sidebar-brand"
            [matMenuTriggerFor]="(showLocationsList && show_location) ? locationListMenu : null">
            <div class="sidebar-brand__top">
              <a routerLink="/" class="brand-logo" (click)="$event.stopPropagation()">
                <img src="assets/default-trakr-logo.svg" alt="trakrSuite" />
              </a>
              <a routerLink="/" class="brand-mark" (click)="$event.stopPropagation()">
                <img src="assets/trakr_icon.svg" alt="" />
              </a>
            </div>
            <div class="brand-text">
              <mat-icon class="brand-loc-pin">place</mat-icon>
              <span class="brand-loc">{{ localName$ | async }}</span>
              <mat-icon class="brand-chevron" *ngIf="showLocationsList && show_location">unfold_more</mat-icon>
            </div>
          </div>

          <!-- Navigation -->
          <nav class="sidebar-nav">
            <mat-nav-list>
              <app-navbar></app-navbar>
            </mat-nav-list>
          </nav>

          <!-- User Card (bottom) -->
          <div class="sidebar-user" [matMenuTriggerFor]="menu">
            <div class="user-avatar">
              <img *ngIf="profileImage$ | async as img; else initialsTpl" [src]="img" alt="" class="user-avatar__img" />
              <ng-template #initialsTpl>{{ userInitials }}</ng-template>
            </div>
            <div class="user-details">
              <span class="user-name">{{ user?.usrFirstName }} {{ user?.usrLastName }}</span>
              <span class="user-role">{{ user?.usrIsPrivileged == 1 ? 'Administrator' : 'User' }}</span>
            </div>
            <mat-icon class="user-menu-icon">more_vert</mat-icon>
          </div>

          <!-- Footer -->
          <div class="sidebar-footer">
            <a href="https://www.trakrsuite.com/privacy-policy" target="_blank">{{ "privacyPolicy" | translate }}</a>
            <span class="version">v{{ panelVersion }}</span>
          </div>
        </div>

        <!-- User Menu -->
        <mat-menu #menu="matMenu" class="sidebar-dropdown" xPosition="after">
          <div class="sd-section">
            <button mat-menu-item class="sd-item sd-item--control" (click)="onStopProp($event)">
              <app-light-dark-switch></app-light-dark-switch>
            </button>
            <button mat-menu-item class="sd-item sd-item--control" (click)="onStopProp($event)">
              <app-language-selector id="language-icon"></app-language-selector>
            </button>
          </div>

          <mat-divider></mat-divider>

          <div class="sd-section">
            <button mat-menu-item class="sd-item" routerLink="profile">
              <mat-icon>person_outline</mat-icon>
              {{ "nav.sub.profile" | translate }}
            </button>
            <button mat-menu-item class="sd-item" (click)="openSupportContact()">
              <mat-icon>mail_outline</mat-icon>
              {{ "support.menuItem" | translate }}
            </button>
            <button mat-menu-item class="sd-item logout-item" (click)="logOut()">
              <mat-icon>logout</mat-icon>
              {{ "logout" | translate }}
            </button>
          </div>
        </mat-menu>

        <!-- Location Menu -->
        <mat-menu #locationListMenu="matMenu">
          <span mat-menu-item *ngFor="let location of locationList" (click)="changeLocation(location[0], location[1])">
            <mat-radio-group [(ngModel)]="selectedLocation[0]">
              <mat-radio-button [value]="+location[0]">{{ location[1] }}</mat-radio-button>
            </mat-radio-group>
          </span>
        </mat-menu>
      </mat-sidenav>

      <mat-sidenav-content>
        <div class="contentLayout">
          <div id="top"></div>
          <mat-toolbar class="example-toolbar tp-header" color="primary">
            <button mat-icon-button class="contentLayout__menuBtn mr-15" (click)="onToggle()">
              <mat-icon class="menu-btn">menu</mat-icon>
            </button>

            <!-- Breadcrumb: "Dashboard" on home, "Dashboard / <page>" elsewhere -->
            <div class="tp-crumb">
              <a routerLink="/" class="tp-crumb__root">{{ 'nav.sub.dashboard' | translate }}</a>
              <ng-container *ngIf="isHome$ == false">
                <span class="tp-crumb__sep">/</span>
                <ng-container *ngIf="title$ && title$.startsWith('reports.')">
                  <a routerLink="/reports" class="tp-crumb__root">{{ 'nav.sub.reports' | translate }}</a>
                  <span class="tp-crumb__sep">/</span>
                </ng-container>
                <span class="tp-crumb__cur">{{ "nav.sub." + title$ | translate }}</span>
              </ng-container>
            </div>

            <span class="tp-header__spacer"></span>
            <div id="logo-wrapper" class="tp-header__logo"></div>
          </mat-toolbar>

          <!-- Trial ended without payment, counts down to the payment screen -->
          <div class="billing-banner" *ngIf="(billingState$ | async)?.state === 'grace'">
            <mat-icon>error_outline</mat-icon>
            <span class="billing-banner__text">
              {{ 'billing.graceBanner' | translate:{ days: (billingState$ | async)?.days_left } }}
            </span>
            <button mat-flat-button color="primary"
              *ngIf="(billingState$ | async)?.can_manage_billing && (billingState$ | async)?.has_billing_account"
              (click)="onManageBilling()">{{ 'billing.payNow' | translate }}</button>
          </div>

          <div class="outlet-bg">
            <!-- Page header: big title like the dashboard greeting (hidden on home,
                 which has its own "Welcome Back" greeting). -->
            <div class="tp-page-head" *ngIf="isHome$ == false && title$ && !selfHeaderPages.includes(title$)">
              <h1 class="tp-page-head__title">{{ "nav.sub." + title$ | translate }}</h1>
            </div>
            <div class="contentLayout__outletWrapper">
              <router-outlet #outlet="outlet"></router-outlet>
            </div>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
